module.exports = __webpack_public_path__ + "static/media/modulo-configurador.091acac7.svg";